export default {
  SET_REPORT_ORG: "SET_REPORT_ORG",
  SEARCH_ORGS_REQUEST: "SEARCH_ORGS_REQUEST",
  SEARCH_ORGS_RECEIVE: "SEARCH_ORGS_RECEIVE",
  SEARCH_ORGS_ERROR: "SEARCH_ORGS_ERROR",
  GET_TRANSACTIONS_REPORT_REQUEST: "GET_TRANSACTIONS_REPORT_REQUEST",
  GET_TRANSACTIONS_REPORT_RECEIVE: "GET_TRANSACTIONS_REPORT_RECEIVE",
  GET_TRANSACTIONS_REPORT_ERROR: "GET_TRANSACTIONS_REPORT_ERROR"
};
